var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.266 15.999c-.669 0-1.21.571-1.21 1.257 0 .669.525 1.256 1.21 1.256.685 0 1.226-.587 1.226-1.256 0-.686-.557-1.257-1.226-1.257z",
    fill: "#272726"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#272726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M10.5 5.5v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.527 16.066c0 .71-.372 1.37-.972 1.725l-6.88 4.07a1.907 1.907 0 0 1-1.942 0l-6.88-4.07a2.007 2.007 0 0 1-.973-1.725V7.934c0-.71.373-1.37.972-1.725l6.881-4.07a1.906 1.906 0 0 1 1.941 0l6.881 4.07c.6.354.972 1.015.972 1.725v8.132zm-.059-11.482L12.588.515a3.7 3.7 0 0 0-3.768 0l-6.881 4.07C.775 5.272.052 6.555.052 7.934v8.13c0 1.379.723 2.662 1.887 3.35l6.88 4.07a3.701 3.701 0 0 0 3.769 0l6.88-4.07c1.165-.688 1.888-1.971 1.888-3.35v-8.13c0-1.379-.723-2.662-1.888-3.35z",
    fill: "#272726"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.c1e59c5a66767c29828d7ebc46f21985.svg";
export { ForwardRef as ReactComponent };